import metricResetTypes from 'constants/metric-reset-types';

export function getProductDefaultValues() {

  const product = {
    _id: null,
    name: '',
    description: '',
    price: {
      unitAmount: ''
    },
    successURL: '',
    cancelURL: '',
    taxCateogry: '',
    metadata: {
      '': ''
    },
    metrics: [{
      name: '',
      allowedCount: '',
      usedCount: '',
      reset: metricResetTypes.NEVER,
      unitAmount: ''
    }],
    defaultProduct: false,
    visibleToPublic: true,
    thresholdAmount: 0,
    promotionCodes: []
  };

  return product;

}